"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CountryFlag = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * UI component for user badge inside the my profile component
 */
const CountryFlag = ({
  countryCode,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
  className: `ccl__country-flag fi-${countryCode.toLowerCase()}`,
  "data-nw-flag": countryCode.toLowerCase(),
  ...props
});
exports.CountryFlag = CountryFlag;
CountryFlag.defaultProps = {};